"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _globals = _interopRequireWildcard(require("@insided/shared/utils/globals"));

var _classnames = _interopRequireDefault(require("classnames"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var UserName = function UserName(_ref) {
  var _user$rank, _user$rank2, _user$rank3, _user$rank$color, _user$rank4, _user$rank5;

  var user = _ref.user,
      _ref$extraClass = _ref.extraClass,
      extraClass = _ref$extraClass === void 0 ? '' : _ref$extraClass,
      _ref$children = _ref.children,
      children = _ref$children === void 0 ? null : _ref$children;
  var customClasses = [];

  if (user !== null && user !== void 0 && (_user$rank = user.rank) !== null && _user$rank !== void 0 && _user$rank.isBold) {
    customClasses.push('rank--bold');
  }

  if (user !== null && user !== void 0 && (_user$rank2 = user.rank) !== null && _user$rank2 !== void 0 && _user$rank2.isItalic) {
    customClasses.push('rank--italic');
  }

  if (user !== null && user !== void 0 && (_user$rank3 = user.rank) !== null && _user$rank3 !== void 0 && _user$rank3.isUnderline) {
    customClasses.push('rank--underlined');
  }

  if (user.id && user.name && !user.url) {
    user.url = "".concat((0, _globals.getSubfolderPrefix)(), "/members/").concat(user.name.toLowerCase(), "-").concat(user.id);
  }

  return user.id ? (0, _preact.h)("span", {
    className: "user-name-wrapper"
  }, (0, _preact.h)("a", {
    className: (0, _classnames.default)("qa-username link--user ".concat(customClasses.join(' '), " ").concat(extraClass || '', " hover-underline")) // eslint fix for  @typescript-eslint/prefer-optional-chain
    ,
    style: {
      color: (_user$rank$color = user === null || user === void 0 ? void 0 : (_user$rank4 = user.rank) === null || _user$rank4 === void 0 ? void 0 : _user$rank4.color) !== null && _user$rank$color !== void 0 ? _user$rank$color : ''
    },
    href: (0, _absoluteUrlRuntime.resolveUrl)((0, _globals.default)('application') !== 'control' ? user.url : "".concat((0, _globals.getSubfolderPrefix)(), "/member/profile?userid=").concat(user.id))
  }, user.name), Array.isArray(children) && children.length ? (0, _preact.h)("span", {
    style: {
      color: ((_user$rank5 = user.rank) === null || _user$rank5 === void 0 ? void 0 : _user$rank5.color) || 'inherit'
    }
  }, children) : null) : (0, _preact.h)("div", {
    className: (0, _classnames.default)('link--user qa-username default-cursor')
  }, user.name);
};

var _default = UserName;
exports.default = _default;